import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HideHeaderDirective } from './hide-header.directive';
import { InsertHtmlDirective } from './insert-html.directive';
import { SelectDirective } from './select.directive';

const declarations = [
  HideHeaderDirective,
  InsertHtmlDirective,
  SelectDirective
]

@NgModule({
  declarations,
  imports: [
    CommonModule
  ],
  exports: declarations
})
export class SharedModule { }
